import { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import ApiUserPayment from "../../../core/api/api.userPayment";
import DataGrid from "./DataGrid";
import { NumericFormat } from "react-number-format";
import ApiPaymentService from "../../../core/api/api.paymentService";
import _ from "lodash";
import { tools } from "../../../core/utils/tools";
import { ViewModal } from "./ViewModal";
import SelectComponent from "../_Components/ReactSelectComponent";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";
import GlobalFormControl from "../_Components/GlobalFormControl";

const userPaymentStatusList = [
  { id: "", title: "-----" },
  { id: "1", title: "انجام شد" },
  { id: "0", title: "رد شد" },
  { id: "2", title: "ورود به درگاه" },
];

export const UserPayment = () => {
  const [listData, setListData] = useState([{}]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [portalList, setPortalList] = useState([]);
  let location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  let background = location.state && location.state.background;
  const [showModalUserPayment, setShowModalUserPayment] = useState(false);
  const [selectedUserPayment, setSelectedUserPayment] = useState(null);
  const [isExcel, setIsExcel] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        // دریافت لیست درگاه ها
        const data1 = await ApiPaymentService.getPortalList({
          pageSize: 100,
        });
        setPortalList(data1.data);
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : getValues("pageSize");
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1)
          ? _.toNumber(pageNumberFromUrl1)
          : getValues("pageNumber");
        const selectedItems = !_.isEmpty(searchParams.get("portalList"))
          ? data1.data
            .filter((item) => searchParams.get("portalList").includes(item.id.toString()))
            .map((item) => ({
              value: item.id,
              label: `${item.title}`,
            }))
          : undefined;

        const data = await ApiUserPayment.getAllUserPayment({
          firstName: searchParams.get("firstName"),
          lastName: searchParams.get("lastName"),
          phoneNumber: searchParams.get("phoneNumber"),
          fromAmount: searchParams.get("fromAmount"),
          toAmount: searchParams.get("toAmount"),
          basketId: searchParams.get("basketId"),
          basketItemPersonId: searchParams.get("basketItemPersonId"),
          portalList: searchParams.get("portalList"),
          paymentStatus: searchParams.get("paymentStatus"),
          globalSearch: searchParams.get("globalSearch"),
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
          createdTimeOf: searchParams.get("createdTimeOf"),
          createdTimeTo: searchParams.get("createdTimeTo"),
          orderId: searchParams.get("orderId"),
          userCardNumber: searchParams.get("userCardNumber"),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "firstName", type: "text" },
          { name: "lastName", type: "text" },
          { name: "phoneNumber", type: "text" },
          { name: "basketId", type: "text" },
          { name: "userCardNumber", type: "text" },
          { name: "fromAmount", type: "text" },
          { name: "toAmount", type: "text" },
          { name: "orderId", type: "text" },
          { name: "basketItemPersonId", type: "text" },
          { name: "portalList", type: "multiSelect", isMulti: true, data: data1.data },
          { name: "paymentStatus", type: "multiSelect", isMulti: false, data: userPaymentStatusList },
          { name: "createdTimeOf", type: "datePicker" },
          { name: "createdTimeTo", type: "datePicker" },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  function handleChangeMulti(value) {
    setValue("portalList", value);
  }

  const onSubmit = async (data) => {
    if (!_.isEmpty(data.fromAmount) && !validateNumberFromAmount(data.fromAmount)) return;
    if (!_.isEmpty(data.toAmount) && !validateNumberToAmount(data.toAmount)) return;
    if (!_.isEmpty(data.basketId) && !validateNumberBasketId(data.basketId)) return;
    if (!_.isEmpty(data.orderId) && !validateNumberBasketId(data.orderId)) return;
    if (!_.isEmpty(data.basketItemPersonId) && !validateNumberBasketPersonId(data.basketItemPersonId)) return;
    data.pageNumber = getValues("pageNumber");
    data.fromAmount = data?.fromAmount?.replaceAll(",", "");
    data.toAmount = data?.toAmount?.replaceAll(",", "");
    if (data.portalList?.length > 0) data.portalList = _.toString(data.portalList?.map((item) => item.value));
    data.paymentStatus = data.paymentStatus?.value;
    if (data.createdTimeOf !== null && typeof data.createdTimeOf === "object") {
      data.createdTimeOf = tools.DateFormat(data.createdTimeOf);
    }
    if (data.createdTimeTo !== null && typeof data.createdTimeTo === "object") {
      data.createdTimeTo = tools.DateFormat(data.createdTimeTo);
    }
    tools.setPageNumber(data, searchParams, setValue);
    if (isExcel) {
      await ApiUserPayment.getAllUserPaymentToExcel(data).then((response) => {
        const fileBlobUrl = URL.createObjectURL(new Blob([response]));
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.id = "file" + Math.floor(Math.random() * 100);
        anchor.href = fileBlobUrl;
        anchor.download = "PaymentReport.xlsx";
        document.body.appendChild(anchor);
        anchor.click();
      });
      setIsExcel(false)
    }
    const apiData = await ApiUserPayment.getAllUserPayment(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/userPayment?${queryString}`);
  };
  const validateNumberFromAmount = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("fromAmount", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("fromAmount");
      return true;
    }
  };
  const validateNumberToAmount = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("toAmount", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("toAmount");
      return true;
    }
  };
  const validateNumberBasketId = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketId", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("basketId");
      return true;
    }
  };
  const validateNumberBasketPersonId = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketItemPersonId", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("basketItemPersonId");
      return true;
    }
  };
  const validateNumberOrderId = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("orderId", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("orderId");
      return true;
    }
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت پرداخت ها</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست دستور پرداخت ها</span>
          </h3>
          <div className="card-toolbar">
            {/* <Button variant="success" onClick={handleShow}>
                            <AddCircle className='mr-1' />
                             ایجاد مجوز جدید
                    </Button> */}
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" key={1} onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link" >
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="firstName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="lastName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام خانوادگی"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="phoneNumber"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره موبایل"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  type="search"
                                  //thousandSeparator=","
                                  //decimalScale="0"
                                  //prefix=" تومان "
                                  onChange={onChange}
                                />
                                //  <TextField
                                //         label='شماره موبایل'
                                //         margin="normal"
                                //         variant="outlined"
                                //         size='small'
                                //         value={value || ""}
                                //         onChange={onChange}
                                //     />
                              )}
                              onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                  e.stopPropagation()
                                }
                              }}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="userCardNumber"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره کارت کاربر"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  type="search"
                                  onChange={onChange}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="basketId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره سفارش"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketId}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketId(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                  type="search"
                                />
                              )}
                            />
                            {errors.basketId && (
                              <div className="text-small-1 text-danger"> {errors.basketId.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="basketItemPersonId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره بلیط"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketItemPersonId}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketPersonId(values.value);
                                  }}
                                  type="search"
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketItemPersonId && (
                              <div className="text-small-1 text-danger"> {errors.basketItemPersonId.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="orderId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره درخواست"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.orderId}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberOrderId(values.value);
                                  }}
                                  type="search"
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.orderId && (
                              <div className="text-small-1 text-danger"> {errors.orderId.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive  px-2" style={{ zIndex: 50 }}>
                            <Controller
                              name="paymentStatus"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="وضعیت"
                                  options={userPaymentStatusList?.map((item) => ({
                                    value: item.id,
                                    label: item.title,
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="fromAmount"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="از مبلغ"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  decimalScale="0"
                                  error={!!errors.fromAmount}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberFromAmount(values.value);
                                  }}
                                  type="search"
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.fromAmount && (
                              <div className="text-small-1 text-danger"> {errors.fromAmount.message}</div>
                            )}
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="toAmount"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="تا مبلغ"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  decimalScale="0"
                                  error={!!errors.toAmount}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberToAmount(values.value);
                                  }}
                                  type="search"
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.toAmount && (
                              <div className="text-small-1 text-danger"> {errors.toAmount.message}</div>
                            )}
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive  px-2" style={{ zIndex: 50 }}>
                            <Controller
                              name="portalList"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5 w-20"
                                  placeholder="درگاه"
                                  options={portalList?.map((item) => ({
                                    value: item.id,
                                    label: item.id + "-" + item.titleShow,
                                  }))}
                                  field={field}
                                  onChange={handleChangeMulti}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="6" xl="3" className="tb-responsive px-2 mt-5">
                            <Controller
                              name="createdTimeOf"
                              control={control}
                              render={({ field: { onChange, value } }) => {
                                return (
                                  <ShamsiDatePicker
                                    value={value}
                                    onChange={(date) => {
                                      var createdTimeTo = getValues("createdTimeTo");
                                      onChange(date);
                                      if (
                                        !createdTimeTo ||
                                        (date?.toDate && date?.toDate()?.getTime() > new Date(createdTimeTo).getTime())
                                      ) {
                                        // Set the value of createTimeTo to the same as createTimeTo
                                        setValue("createdTimeTo", date);
                                      }
                                    }}
                                    placeholder="زمان ایجاد از"
                                  />
                                );
                              }}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2 mt-5">
                            <Controller
                              name="createdTimeTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker value={value} onChange={onChange} placeholder="زمان ایجاد تا" />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" className="tb-reponsive mt-3 px-2">
                            <Button
                              variant="success"
                              type="submit"
                              disabled={isSubmitting}
                            >
                              {(isSubmitting && !isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              className="ml-3"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                tools.handleResetAdvanceSearchBox(watch, reset);
                              }}
                            >
                              {(isSubmitting && !isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                            <Button
                              className="ml-4"
                              variant="info"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsExcel(true);
                              }}
                            >
                              {(isSubmitting && isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <InsertDriveFile /> فایل اکسل
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0 text-center">
                <DataGrid
                  data={listData}
                  setShowModalUserPayment={setShowModalUserPayment}
                  setSelectedUserPayment={setSelectedUserPayment}
                />
              </Col>
              {showModalUserPayment && (
                <ViewModal
                  showModalUserPayment={showModalUserPayment}
                  setShowModalUserPayment={setShowModalUserPayment}
                  selectedUserPayment={selectedUserPayment}
                />
              )}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};
